import { IUserPlayer } from "@grassrootly/api";
import { Div, Label } from "@grassrootly/rn-core";
import { Image } from "react-native";
import { images } from "../../layout/assets";
import moment from "moment";

export default function ProfileInfo({ player }: { player: IUserPlayer }) {
  return (
    <Div classNames={["flex1"]}>
      <Image
        style={{ height: 160, width: 160, borderRadius: 160, marginLeft: "auto", marginRight: "auto" }}
        resizeMode="cover"
        source={player.profile_picture ? { uri: player.profile_picture } : images.playerAvatar}
      />
      <Div classNames={["flex1", "w100", "maxW-{300}", "mt-{24}"]}>
        <Div classNames={["mb-{16}"]}>
          <Label
            type="l3Regular"
            fitContent
            classNames={["borderPrimary", "borderSolid", "bw-{0}", "bwBottom-{1}", "italic", "alignSelfFlexStart"]}
          >
            Name
          </Label>
          <Label>{player.name}</Label>
        </Div>
        <Div classNames={["mb-{16}"]}>
          <Label
            type="l3Regular"
            fitContent
            classNames={["borderPrimary", "borderSolid", "bw-{0}", "bwBottom-{1}", "italic", "alignSelfFlexStart"]}
          >
            Email
          </Label>
          <Label>{player.user.email}</Label>
        </Div>
        <Div classNames={["mb-{16}"]}>
          <Label
            type="l3Regular"
            fitContent
            classNames={["borderPrimary", "borderSolid", "bw-{0}", "bwBottom-{1}", "italic", "alignSelfFlexStart"]}
          >
            Member since
          </Label>
          <Label>{moment(player.created_at).format("DD.MM.YYYY")}</Label>
        </Div>
      </Div>
    </Div>
  );
}
